<template>
	<loading :active="true" is-full-screen>
		<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
	</loading>
</template>
<script>
	import VueElementLoading from 'vue-element-loading'
	export default {
		props : ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		created() {
			this.$auth.destroyToken()
			window.location.href = "/" + this.$i18n.locale + "/" + this.$platform.slug
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/authentication/views/Logout.vue